<template>
    <div>
        <b-button variant="dark" @click="show = true"><i class="fa fa-file-code-o"></i> </b-button>
        <b-modal title="Snippets" v-model="show">
            <b-row>
                <b-col>
                    <span v-if="snippets.length < 1"> You don't have any snippets yet! To create new snippet select code and press <strong>CTRL + P</strong></span>
                    <b-list-group>
                        <b-list-group-item button v-for="snippet in snippets" :key="snippet.uuid">
                            {{ snippet.name }}

                            <i class="fa fa-close fa-lg float-right icon-control" @click="remove(snippet)"></i>
                            <i class="fa fa-file-text-o fa-lg float-right icon-control" @click="edit(snippet)"></i>
                            <i class="fa fa-check fa-lg float-right icon-control" @click="useSnippet(snippet)"></i>
                        </b-list-group-item>
                    </b-list-group>
                </b-col>
            </b-row>
        </b-modal>

        <b-modal title="Snippet" v-model="snippetModal.show">
            <InputField label="Name" name="name" :rules="{required: true, length: {min: 2}}" v-model="snippetModal.name"/>

            <template v-slot:modal-footer>
                <b-button variant="light" @click="snippetModal.show = false"> Cancel </b-button>
                <b-button variant="success" @click="save"> Save </b-button>
            </template>
        </b-modal>

        <b-modal size="xl" title="Edit snippet" v-model="editSnippetModal.show">
            <InputField label="Name" name="name" :rules="{required: true, length: {min: 2}}" v-model="editSnippetModal.snippet.name"/>
            
            <b-form-group>
                <codemirror v-model="editSnippetModal.snippet.code" :options="editSnippetModal.options"></codemirror>
            </b-form-group>

            <template v-slot:modal-footer>
                <b-button variant="light" @click="editSnippetModal.show = false"> Cancel </b-button>
                <b-button variant="success" @click="editSnippet"> Save </b-button>
            </template>
        </b-modal>
    </div>
</template>

<style scoped>
.icon-control {
    margin: 0px 5px;
}
</style>

<script>
import InputField from '../Input'

// require component
import * as vueCodemirror from 'vue-codemirror'
import 'codemirror/lib/codemirror.css'
import 'codemirror/addon/display/autorefresh.js'
import 'codemirror/mode/javascript/javascript.js'

export default {
    name: "Snippets",
    components: {
        InputField,
        codemirror: vueCodemirror.codemirror
    },
    props: {
        libs: {
            type: Array
        },
        code: {
            type: String
        }
    },
    watch: {
        code(newVal, oldVal) {
            if (newVal != "") {
                this.snippetModal.show = true;
                this.snippetModal.code = newVal;
            }
        }
    },
    data: function() {
        return {
            show: false,
            snippetModal: {
                show: false,
                name: '',
                code: ''
            },
            editSnippetModal: {
                show: false,
                snippet: {
                    uuid: '',
                    name: '',
                    code: ''
                },
                options: {
                    tabSize: 4,
                    lineNumbers: true,
                    line: true,
                    autoRefresh: true,
                    foldGutter: true,
                    styleSelectedText: true,
                    mode: 'text/javascript',
                    matchBrackets: true,
                    showCursorWhenSelecting: true
                }
            },
            snippets: []
        }
    },

    methods: {
        useSnippet(snippet) {
            this.$emit("snippetUsed", snippet);
        },

        save() {
            this.$http.post("/v1/system/snippets", {name: this.snippetModal.name, code: this.snippetModal.code}).then(resp => {
                this.snippets.push(resp.data);

                this.snippetModal.show = false;
                this.snippetModal.name = '';
                this.snippetModal.code = '';
            }).catch(error => {
                if (error.response.status == 500) {
                    this.$serverErrorModal(error)
                    return
                }

                this.$bvModal.msgBoxOk(error.response.data.message)
            })
        },

        edit(snippet) {
            this.editSnippetModal.show = true;
            this.editSnippetModal.snippet = snippet;
        },

        editSnippet() {
            this.$http.put("/v1/system/snippets/" + this.editSnippetModal.snippet.uuid, this.editSnippetModal.snippet).then(resp => {
                this.editSnippetModal.show = false;
            }).catch(error => {
                if (error.response.status == 500) {
                    this.$serverErrorModal(error)
                    return
                }

                this.$bvModal.msgBoxOk(error.response.data.message)
            })
        },

        remove(snippet) {
            this.$bvModal.msgBoxConfirm("Are you sure you want to delete this snippet?").then(resp => {
                if (resp) {
                    this.$http.delete("/v1/system/snippets/" + snippet.uuid).then(resp => {
                        this.snippets = this.snippets.filter(s => {
                            return s.uuid != snippet.uuid;
                        });

                    }).catch(error => {
                        if (error.response.status == 500) {
                            this.$serverErrorModal(error)
                            return
                        }

                        this.$bvModal.msgBoxOk(error.response.data.message)
                    })
                }
            })
        }

    },

    mounted() {
        this.$http.get("/v1/system/snippets").then(resp => {
            this.snippets = resp.data;
        }).catch(error => {
            if (error.response.status == 500) {
                this.$serverErrorModal(error)
                return
            }

            this.$bvModal.msgBoxOk(error.response.data.message)
        })
    }
}
</script>